export const DEFAULT_ANALYSIS_SETTINGS = {
    faceRecognition: true,
    licensePlateRecognition: true,
    opticalCharacterRecognition: true,
    analysisFramesPerSecond: 5,
} as const;
